module.exports = __webpack_public_path__ + "static/media/img.99dcd107.jpg";